import {Component} from '@angular/core';

@Component({
    templateUrl: './error-403.component.html',
    styleUrls: ['./error-403.component.scss'],
    standalone: false
})
export class Error403Component {

}
